import { createContext, useContext, useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase';

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // This effect is a placeholder for future initialization
    // Admin checking is handled by checkAdminForUser when user is available
    return () => {};
  }, []);

  // Function to check admin status for a specific UID
  const checkAdminForUser = (uid) => {
    if (!uid) {
      setIsAdmin(false);
      setRole(null);
      setLoading(false);
      return;
    }

    let unsubscribe = null;

    unsubscribe = onSnapshot(
      doc(db, 'admins', uid),
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const adminData = docSnapshot.data();
          setIsAdmin(true);
          setRole(adminData.role || 'admin');
        } else {
          setIsAdmin(false);
          setRole(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error checking admin status:', err);
        setError(err.message);
        setIsAdmin(false);
        setRole(null);
        setLoading(false);
      }
    );

    return unsubscribe;
  };

  const value = {
    isAdmin,
    loading,
    role,
    error,
    checkAdminForUser,
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export function useAdmin() {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
}
